import React, { useEffect, useState } from "react";
import { OptionProps, components } from 'react-select';
import { RadioTypes } from "../../../../commonTypes/universalTypes";
import { CreateMenuPayloadType } from "../../../../commonTypes/userManagementTypes";
import { MenuType } from "../../../../redux/userManagement/userManagementTypes";
import AddEditModalData from "./AddEditModalData";


export type ModeType = {
  value: string | null | number;
  label: string;
};

export const SELECT_CATEGORY_OPTION: ModeType[] = [
  {
    value: "side_menu",
    label: "Side Menu",
  },
  {
    value: "module",
    label: "Module",
  },
  {
    value: "others",
    label: "Others",
  }
];

const RADIO_OPTIONS: RadioTypes[] = [
 {
    id: "1",
    name: "Client",
  },
  {
    id: "0",
    name: "User",
  },
];

const COMING_SOON_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Yes"
  },
  {
    id: "0",
    name: "No",
  }
];

const IS_NEW_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Yes"
  },
  {
    id: "0",
    name: "No",
  }
];

export type SelectParentType = {
  value:  null |number;
  label: string | undefined;
};

type AppProps = {
  token: string | null;
  success: number | null;
  error: string | null;
  setShowAddMenuModal: any;
  handleSubmit: (data:any)=>void;
  allMenuList: MenuType[];
  isEdit:boolean;
  handleResetEditData:()=>void;
  toggleAddAccountModal:()=>void;
  editMenuDetailsData:any;
  handleEditMenuDetails:any
};

const AddEditModal = ({
  token,
  setShowAddMenuModal,
  handleSubmit,
  allMenuList,
  isEdit,
  editMenuDetailsData,
  handleResetEditData,
  handleEditMenuDetails
}: AppProps) => {
  const [isClientUrl, setIsClientUrl] = useState<string>(RADIO_OPTIONS[0].id);
  const [isCommingSoon, setIsCommingSoon] = useState<string>(COMING_SOON_OPTIONS[0].id);
  const [isNew, setIsNew] = useState<string>(IS_NEW_OPTIONS[0].id);
  const [finalParentList, setFinalParentList] = useState<[]>([]);
  const [categorySelected, setCategorySelected] = useState<ModeType>({
    value: null,
    label: 'Select Menu Category...',
  });

const [parentSelected, setParentSelected] = useState<SelectParentType>({
    value: 0,
    label: 'Select Parent Name...'
  });

  const [menuDetails, setMenuDetails] = useState<CreateMenuPayloadType>({
    menuName: "",
    actionName: "",
    finacKey: "",
    menuCategory: "",
    frontendRoute: "",
    activeIcon: "",
    icon: "",
    apiUrl: "",
    description:"",
    paramsType:"",
    token
  });

  const [menuDetailsError, setMenuDetailsError] =
    useState<any>({
      finacKeyError: "",
      selectCategoryError: "",
      menuNameError: ""
    });

  const { menuName, actionName, finacKey, apiUrl, frontendRoute, activeIcon, icon ,description ,paramsType} = menuDetails

  const handleMenuDetailsChange = (e: any) => {
    
    setMenuDetails((prevstate: any) => ({
      ...prevstate,
      [e.target.name]: e.target.value,
    }))
    if(e.target.value&&e.target.name=="menuName"){
      setMenuDetailsError((prev:any)=>({
        ...prev,
        menuNameError: "",
      }))
    }
    else if(e.target.value&&e.target.name=="finacKey"){
      setMenuDetailsError((prev:any)=>({
        ...prev,
        finacKeyError: "",
      }))
    }
  }

  useEffect(() => {
    if (isEdit) {
      if (allMenuList && allMenuList?.length > 0) {
        editHandleManipulateMenuListData(allMenuList);
      }
    } else {
      if (allMenuList && allMenuList?.length > 0) {
        addHandleManipulateMenuListData(allMenuList)
      }
   
  }}, [allMenuList,isEdit])

  const handleSetRadioValue = (radioValue: string) => {
    setIsClientUrl(radioValue);
  };

  const handleChangeSelectedMode = (mode: any) => {
    setCategorySelected(mode);
    if(categorySelected){
      setMenuDetailsError((prev:any)=>({
        ...prev,
        selectCategoryError: "",
      }))
    }
  }
  const handleSetCommingSoonValue = (mode: any) => {
    setIsCommingSoon(mode)
  }
  const handleSetIsNewValue = (mode: any) => {
    setIsNew(mode)
  }

  const Option = (props: OptionProps<any, false>) => {
    return (
      <components.Option {...props}>
        <ul className={`ledger-list`}>
          <li
            style={{
              paddingLeft: `${props?.data?.count !== undefined ? props?.data?.count * 10 : "0"
                }px`,
            }}
          >
            <span
              className={
                props?.data?.count === undefined
                  ? ""
                  : "stock-nested-list no-show"
              }
            >
              {props?.data?.label}
            </span>
          </li>
        </ul>
      </components.Option>
    );
  };


  const addHandleManipulateMenuListData = (
    parentData: any,
    finalData: any = []
  ) => {
    let count = 0;
    function getAllData(arr: any) {
      arr.map((e: any, i: number) => {
        if (count > 0) {
          finalData.push({
            menu_name: e?.menu_name,
            menu_id: e?.menu_id,
            count,
          });
        } else {
          finalData.push({
            menu_name: e?.menu_name,
            menu_id: e?.menu_id,
          });
        }
        if (e.sub_menu.length > 0) {
          count++;
          getAllData(e.sub_menu);
          count--;
        }
      });
    }

    getAllData(parentData);
    setFinalParentList(finalData.map((e:any)=>({label:e.menu_name,value:e.menu_id,count:e.count})));
  };

  const editHandleManipulateMenuListData=(
    parentData: any,
    finalData: any = []
  ) => {
    let count = 0;
    function getAllData(arr: any) {
      let new_arr = arr?.filter(
        (el: any) => el?.menu_id != editMenuDetailsData?.menu_id
        );
      new_arr.map((e: any, i: number) => {
        if (count > 0) {
          finalData.push({
            menu_name: e?.menu_name,
            menu_id: e?.menu_id,
            count,
          });
        } else {
          finalData.push({
            menu_name: e?.menu_name,
            menu_id: e?.menu_id,
          });
        }
        if (e.sub_menu.length > 0) {
          count++;
          getAllData(e.sub_menu);
          count--;
        }
      });
    }
    getAllData(parentData);
    setFinalParentList(finalData.map((e:any)=>({label:e.menu_name,value:e.menu_id,count:e.count})));
  }

  const handleResetData=()=>{
    setShowAddMenuModal(false)
    setMenuDetailsError((state: any) => ({
      ...state,
      selectCategoryError: "",
      finacKeyError: "",
      frontendRouteError: ""
    }))
  }

  const handleParentData = (mode: any) => {
    setParentSelected({
      value: mode?.value,
      label: mode?.label
    })
  }
  function getMenuNameOnEdit(finalParentList:any):string {  
    return finalParentList?.filter(
      (el: any) =>
        el.value === editMenuDetailsData?.parent_id
    )[0]?.label
   }
  

  useEffect(() => {
    if (isEdit) {
      if(finalParentList.length!==0){
        setParentSelected({
          value: editMenuDetailsData.parent_id,
          label: getMenuNameOnEdit(finalParentList),
        })
      }
     

      setCategorySelected({
        value:editMenuDetailsData.category.value,
        label:editMenuDetailsData.category.label
      })

      setIsNew(
        editMenuDetailsData.is_new===0?IS_NEW_OPTIONS[1].id:IS_NEW_OPTIONS[0].id
      )

      setIsClientUrl(
        editMenuDetailsData.is_client_url===0?RADIO_OPTIONS[1].id:RADIO_OPTIONS[0].id
      )

      setIsCommingSoon(
        editMenuDetailsData.coming_soon===0?COMING_SOON_OPTIONS[1].id:COMING_SOON_OPTIONS[0].id
      )

      setMenuDetails({
      ...menuDetails,
      menuName: editMenuDetailsData.menu_name,
      actionName: editMenuDetailsData.action,
      finacKey: editMenuDetailsData.finac_key,
      menuCategory: editMenuDetailsData.category,
      frontendRoute: editMenuDetailsData.front_end_route,
      activeIcon: editMenuDetailsData.active_icon,
      icon: editMenuDetailsData.icon,
      apiUrl: editMenuDetailsData.api_url,
      description:editMenuDetailsData.description,
      paramsType:editMenuDetailsData.params_type
      })
    }
  }, [isEdit, allMenuList, finalParentList]);


  const handleSubmitForm = () => {

    if (categorySelected.value && finacKey && menuName) {
      handleResetData();
      if (isEdit) {
        let finalEditData = {
          menu_name: menuName,
          front_end_route: frontendRoute,
          api_url: apiUrl,
          is_client_url: isClientUrl,
          parent_id: parentSelected.value,
          category: categorySelected.value,
          action: actionName,
          coming_soon: isCommingSoon,
          finac_key: finacKey,
          active_icon: activeIcon,
          icon: icon,
          is_new: isNew,
          description,
          params_type:paramsType,
          token
        };
        handleEditMenuDetails(finalEditData);
      }
      else{
        let finalData = {
          menu_name: menuName,
          front_end_route: frontendRoute,
          api_url: apiUrl,
          is_client_url: isClientUrl,
          parent_id: parentSelected.value,
          category: categorySelected.value,
          action: actionName,
          coming_soon: isCommingSoon,
          finac_key: finacKey,
          active_icon: activeIcon,
          icon: icon,
          is_new: isNew,
          description,
          params_type : paramsType,
          token
        }
        handleSubmit(finalData)
      }
    }
    else {
      setMenuDetailsError((state: any) => ({
        ...state,
        selectCategoryError: "",
        finacKeyError: "",
        menuNameError: ""
      }))
      if (categorySelected.value === null) {
        setMenuDetailsError((state: any) => ({
          ...state,
          selectCategoryError: "Category is required"
        }))
      }
      if (!finacKey) {
        setMenuDetailsError((state: any) => ({
          ...state,
          finacKeyError: "Finac key is required"
        }))
      }
      if (!menuName) {
        setMenuDetailsError((state: any) => ({
          ...state,
          menuNameError: "Menu name is required"
        }))
      }
    }
  }

  return (
   <AddEditModalData 
   isEdit={isEdit}
    menuDetailsError={menuDetailsError}
    menuDetails={menuDetails}
    handleMenuDetailsChange={handleMenuDetailsChange}
    finalParentList={finalParentList}
    parentSelected={parentSelected}
    handleParentData={handleParentData}
    SELECT_CATEGORY_OPTION={SELECT_CATEGORY_OPTION}
    handleChangeSelectedMode={handleChangeSelectedMode}
    categorySelected={categorySelected}
    RADIO_OPTIONS={RADIO_OPTIONS}
    handleSetRadioValue={handleSetRadioValue}
    isClientUrl={isClientUrl}
    COMING_SOON_OPTIONS={COMING_SOON_OPTIONS}
    handleSetCommingSoonValue={handleSetCommingSoonValue}
    isCommingSoon={isCommingSoon}
    IS_NEW_OPTIONS={IS_NEW_OPTIONS}
    handleSetIsNewValue={handleSetIsNewValue}
    isNew={isNew}
    handleResetEditData={handleResetEditData}
    handleResetData={handleResetData}
    handleSubmitForm={handleSubmitForm}
    Option={Option}
   />
  );
};

export default AddEditModal;
